import { combineReducers } from "redux";

import GetAllInternship from "../features/internship/Slice";

const Internship = combineReducers({
  GetAllInternship: GetAllInternship,
});

export default Internship;
